import { BiDownArrowCircle } from "react-icons/bi"; 
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import { useWindowSize } from '../../hx/useWindowSize';
import { BiLockAlt, BiLockOpenAlt, BiTrash } from "react-icons/bi";
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxBackdrop from '../../cx/CxBackdrop';
import * as FxFetch from '../../fx/FxFetch';
import * as FxTable from '../../fx/FxTable';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { clearStore, StoreSettCalendarHol } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxList from '../../gx/GxList';

const MxSettCalendarHolList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();
  const size = useWindowSize();
  
  const r_list = React.useRef(null);
  
  const [storeSettCalendarHol, setStoreSettCalendarHol] = useSessionStorage('StoreSettCalendarHol', StoreSettCalendarHol);
  
  const [lockDelete, setLockDelete] = React.useState(true);
  const [backdrop, setBackdrop] = React.useState(false);

  React.useEffect(() => {
    clearStore('StoreSettCalendarHol', storeSettCalendarHol);
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  const openForm = async (op, row) => {
    if (row === null) {
      storeSettCalendarHol.itCalendarHol = null;
    } else {
      storeSettCalendarHol.itCalendarHol = row.original.itCalendarHol;
    }
    setStoreSettCalendarHol(storeSettCalendarHol);
    navTo("sett-calendar-hol-form");
  }

  const doDelete = (row) => {
    let record = {};
    record['idValue'] = row.itCalendarHol;
    Promise.all([FxFetch.doJsonF(`sett/cal_hol/d`, null, record)]).then((result) => {
      if (result[0].theValue === 'rv_error') {
      } else {
        r_list.current.refresh();
      }
    });
  }

  const doImport = () => {
    setBackdrop(true);
    let record = {};
    Promise.all([FxFetch.doJsonF(`sett/cal_hol/import`, null, record)]).then((result) => {
      setBackdrop(false);
      if (result[0].theValue === 'rv_error') {
      } else {
        r_list.current.refresh();
      }
    });
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;

    cols.push({ id: id++, Header: "ID", accessor: "itCalendarHol", show: false });

    if (size && size.isLarge) {
      cols.push({ id: id++, Header: trans('field.name'), accessor: "txTypeCalendarHol", highlight: true, width: '60%' });
      cols.push({ id: id++, Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtFrom"]), width: '20%' });
      cols.push({ id: id++, Header: trans('field.national'), accessor: row => (FxTable.cellToYesNo(row["boNational"])), width: '20%', type: 'boolean' });
    } else {
      cols.push({ id: id++, Header: trans('field.name'), accessor: "txTypeCalendarHol", highlight: true, width: '70%' });
      cols.push({ id: id++, Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtFrom"]), width: '30%' });
    }

    cols.push({
      id: "BTN_DEL", icon: <BiLockAlt />, icon_alt: <BiLockOpenAlt />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockDelete(!lockDelete),
      accessor: row => { return <CxIconButtonNew icon={<BiTrash fontSize={24} />} classType="ibs_iconbutton_table_body" data={row} onClick={() => doDelete(row)} disabled={lockDelete} tooltip={trans('field.delete')} /> },
      align: 'center', width: '33px'
    });

    cols.push({ id: 'B', Header: '_national', accessor: row => Boolean(row["boNational"] === '1'), show: false });

    return cols;
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.calendars')}: ${trans('field.holidays')}`}
        xref={r_list}
        tooltip={`${trans('field.holiday')}`}
        fullscreen
        url="sett/cal_hol"
        onOpenForm={openForm}
        columns={getTableColumns()}
        refColors={[ 
          'table_cell_color_blue|' + trans('field.national'), 
        ]}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<BiDownArrowCircle fontSize={23} />} classType="ibs_iconbutton_toolbar" onClick={doImport} tooltip={trans('field.import')} />
          </div>
          
        }
      />

      <CxBackdrop open={backdrop} />
    </div>
  );
}

export default MxSettCalendarHolList;